import React from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'

function LicenseDialog (props) {
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Institutions.IndividualInCharge' {...props} />
        <ModalBody>
          <div className='row'>
            <div className='col-12'>
              <FormRow label='Individuals.Person' name='type' inputType='dropdown' dataSource={context.api.individualService.getCbiEmployees} required />
              <FormRow label='Individuals.Responsibility' name='responsibilityType' inputType='lookup' dataSource={context.cache.getResponsibilityTypes} clientSide isCodeList required />
            </div>
          </div>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  component: LicenseDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/individualInCharge.js